// Auto generated file, do not manually modify!
// com.hotpads.adproducts.api.web.user.billing.handler.AdproductsUserBillingGetInvoicesApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AdproductsScanInvoicesPageDto,
  AdproductsScanInvoicesRequestDto,
  InvoiceListDto,
  InvoiceRequestDto,
  PremiumPaymentHistoryPageDto,
  ScanPremiumPaymentHistoryRequestDto,
} from '../..';

export const AdproductsUserBillingGetInvoicesApiHandler_getInvoices_Path =
  '/api/web/v1/users/billing/invoices/getInvoices';

/**
 * Get list of invoices
 */
export const AdproductsUserBillingGetInvoicesApiHandler_getInvoices = (
  postData: InvoiceRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, InvoiceRequestDto, InvoiceListDto>(
    {
      endpoint: AdproductsUserBillingGetInvoicesApiHandler_getInvoices_Path,
      method: 'POST',
      contextPath: '/adproducts',
      postData: postData,
    },
    client,
  );
};

export const AdproductsUserBillingGetInvoicesApiHandler_scanInvoices_Path =
  '/api/web/v1/users/billing/invoices/scanInvoices';

/**
 * Scan invoices with cursor-based pagination
 */
export const AdproductsUserBillingGetInvoicesApiHandler_scanInvoices = (
  postData: AdproductsScanInvoicesRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, AdproductsScanInvoicesRequestDto, AdproductsScanInvoicesPageDto>(
    {
      endpoint: AdproductsUserBillingGetInvoicesApiHandler_scanInvoices_Path,
      method: 'POST',
      contextPath: '/adproducts',
      postData: postData,
    },
    client,
  );
};

export const AdproductsUserBillingGetInvoicesApiHandler_scanPremiumPaymentHistory_Path =
  '/api/web/v1/users/billing/invoices/scanPremiumPaymentHistory';

/**
 * Scan premium payment history for the authenticated user.
 */
export const AdproductsUserBillingGetInvoicesApiHandler_scanPremiumPaymentHistory = (
  postData: ScanPremiumPaymentHistoryRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, ScanPremiumPaymentHistoryRequestDto, PremiumPaymentHistoryPageDto>(
    {
      endpoint: AdproductsUserBillingGetInvoicesApiHandler_scanPremiumPaymentHistory_Path,
      method: 'POST',
      contextPath: '/adproducts',
      postData: postData,
    },
    client,
  );
};
